import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { memo, useCallback } from 'react';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { setFlightTripSearchInputs } from '../../../../../store/slices/tripSearch';
import Input from '../../../../Input';
import { updateFlightSearchObj } from '../../../../../store/slices/flight';

const FlightNumberInput = ({ tripId, currentIndex, variant }) => {
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const isTripSearch = !tripId;
  const { searchInputs } = useSelector(flightSearchInput(tripId, isTripSearch));
  const flightNumberValue = searchInputs.flightSegments?.[currentIndex]?.flightNumber ?? '';

  const handleFlightNumberChange = useCallback(
    (value) => {
      const payload = {
        tripId,
        searchObj: {
          flightSegments: searchInputs.flightSegments ? [...searchInputs.flightSegments] : [],
          page: 1,
        },
      };

      payload.searchObj.flightSegments[currentIndex] = {
        ...payload.searchObj.flightSegments[currentIndex],
        flightNumber: value,
      };

      if (isTripSearch) dispatch(setFlightTripSearchInputs({ ...payload.searchObj }));
      else dispatch(updateFlightSearchObj(payload));
      track('handleFlightNumberChange.handleChange', {
        flightNumber: value,
        currentIndex,
        tripId,
      });
    },
    [currentIndex, dispatch, isTripSearch, searchInputs.flightSegments, track, tripId],
  );

  return (
    <>
      <Input
        className={`border-gray-500  border-opacity-20 border-2  sm:px-4 sm:py-3 px-4 py-2 text-base font-medium w-full focus:outline-none h-full
                  ${isTripSearch ? 'placeholder-black bg-searchInput-0' : 'placeholder-gray-700 rounded-2xl'} ${variant}`}
        type="input"
        inputMode="numeric"
        maxLength={6}
        placeholder="Flight number"
        title="Flight number"
        onChange={(e) => {
          const { value } = e.target;
          // Allow only digits, max 6
          if (/^\d{0,6}$/.test(value)) {
            handleFlightNumberChange(value);
          }
        }}
        value={flightNumberValue}
      />
    </>
  );
};

FlightNumberInput.propTypes = {
  tripId: PropTypes.string,
  currentIndex: PropTypes.number,
  variant: PropTypes.string,
};

FlightNumberInput.defaultProps = {
  tripId: undefined,
  currentIndex: undefined,
  variant: undefined,
};
export default memo(FlightNumberInput);
